<template>
<!--     <div class="touchscreen-outer">
        <div class="touchscreen"> -->
    <div class="piscreen">
        <nav>
            <div class="quitButton">
                <p class="quit" @click="reset">&#10005;</p>
            </div>

            <div class="optionsButton">
                <p>&#9881;</p>
            </div>
        </nav>
            
        <div class="scorecards">
            <scorecard v-for="(player, index) in players" :key="index" :player="player" v-bind:class="{ 'currentPlayer': currentPlayer == index }"></scorecard>
        </div>

        <calc @submitScore="processScore"></calc>
    </div>


    
<!--         </div>

    </div> -->

</template>

<script>

import axios from 'axios'
import Scorecard from './partials/Scorecard.vue'
import Calc from './partials/Calc.vue'

export default {

    name: 'Game501',

    components: {
        Scorecard,
        Calc
    },

    data() {
        return {
            players: [
                {
                    name: "Frank",
                    score: 501,
                    legs: 0,
                    canFinish: false
                },
                {
                    name: "Ger Bonno",
                    score: 501,
                    legs: 0,
                    canFinish: false
                },
            ],
            currentPlayer: 0,
            startingPlayer: 0
        }
        
    },

    
    methods: {
        processScore(n) {
            // Check if player's score is at least what they typed in.
            if (this.players[this.currentPlayer].score >= n) {
                
                // Player is just scoring some points and not finishing the leg.
                if (this.players[this.currentPlayer].score - n != 0) {
                    this.players[this.currentPlayer].score -= n;
                    this.switchPlayer();
                
                // Player is finishing the leg. Check if it's actually possible.
                } else if (this.players[this.currentPlayer].score - n == 0 && this.players[this.currentPlayer].canFinish) {
                    this.players[this.currentPlayer].score -= n;
                    this.players[this.currentPlayer].legs++;
                    this.nextLeg();
                
                // Player is attempting to finish the leg while unable to finish with 3 darts. Cheater!
                } else {
                    // Probably do some popup error or something.
                    
                }
            } 
        },

        // Switch to the next player.
        switchPlayer() {
            this.currentPlayer++;
            if (this.currentPlayer == this.players.length) {
                this.currentPlayer = 0;
            }
        },

        // Reset scores and start next leg.
        nextLeg() {
            for (let i = 0; i < this.players.length; i++) {
                this.players[i].score = 501;
            }
            this.cycleStartingPlayer();
        },

        // Round-robin starting positions.
        cycleStartingPlayer() {
            this.startingPlayer++;
            if (this.startingPlayer > this.players.length - 1) {
                this.startingPlayer = 0;
            }
            this.currentPlayer = this.startingPlayer;
        },

        // Reset scores and picks a new random player to start the leg.
        reset() {
            for (let i = 0; i < this.players.length; i++) {
                this.players[i].score = 501;
                this.players[i].legs = 0;
            }
            this.chooseRandomPlayer();
        },

        // Picks a random player to start the leg.
        chooseRandomPlayer() {
            let min = 0;
            let max = this.players.length -1;
            let randomPlayer = Math.floor(Math.random() * (max - min + 1)) + min;
            this.startingPlayer = randomPlayer;
            this.currentPlayer = randomPlayer;
        },

        dbtest() {
            // axios.post('/darts_db/test.php', {
            //     'firstname': 'Frank',
            //     'lastname': 'Knarf'
            
            const params = new URLSearchParams();
            params.append('firstname', 'Fred');
            params.append('lastname', 'Flintstone');
            axios.post('/darts_db/test.php', params).then(function (response) {
                console.log(response);
                // console.log("[" + response.status + "] " + response.statusText);
            }).catch(function (error) {
                console.log(error);
            });

        }
    },



    mounted() {
        this.chooseRandomPlayer();
        
        this.dbtest();
    }
}
</script>


<style scoped>

    @font-face {
        font-family: SegoeUI;
        src: url("../../Segoe UI.ttf");
    }

    * {
        font-family: "SegoeUI";
    }

    body {
        background: #444;
        color: #444;
        font-family: "SegoeUI";
    }

    

    

    .scorecards {
        position: absolute;
        right: 290px;
        bottom: 0px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 470px;
        height: 412px;
        flex-wrap: wrap;
        text-align: center;
    }


    nav {
        /*position: absolute;*/
        background: #555;
        height: 56px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }

    .quitButton {
        /*box-shadow: 0 1px 3px rgba(0,0,0,0.48), 0 1px 2px rgba(0,0,0,0.60);*/
        border: 1px solid rgba(0,0,0,0.6);
        border-radius: 10px;
        position: absolute;
        top: 4px;
        right: 27px;
        /*background: #f99;*/
        background: #aaa;
        color: #fff;
        width: 45px;
        height: 45px;
    }

    .quitButton p {
        margin: auto;
        font-size: 36px;
        line-height: 38px;
        padding: 2px 6px 5px 8px;
        cursor: pointer;
        user-select: none;
    }

    .optionsButton {
        /*box-shadow: 0 1px 3px rgba(0,0,0,0.48), 0 1px 2px rgba(0,0,0,0.60);*/
        border: 1px solid rgba(0,0,0,0.6);
        border-radius: 10px;
        position: absolute;
        top: 4px;
        right: 110px;
        /*background: #ec8;*/
        background: #aaa;
        color: #fff;
        width: 45px;
        height: 45px;
    }

    .optionsButton p {
        margin: auto;
        font-size: 40px;
        line-height: 38px;
        padding: 2px 6px 5px 6px;
    }
</style>
